module.exports = __webpack_public_path__ + "img/hamburger.a3ba62fe.svg";